import ObjectViewer from './ObjectViewer.connect';

export default ObjectViewer;
